import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-wrap-mode}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "wrap", "nowrap");
//# sourceMappingURL=text-wrap-mode.js.map